<template>
  <SvgIcon
    :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/volume-high.svg')"
    :size="size"
    v-on="$listeners"
    :button="button"
    :style="rootStyle"
  />
</template>

<script>
import SvgIcon from './SvgIcon'
export default {
  components: {
    SvgIcon,
  },
  props: {
    size: {
      type: Number,
    },
    button: {
      type: Boolean,
      default: true,
    },
    z: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    rootStyle () {
      return {
        'z-index': this.z,
      }
    },
  },
}
</script>
